/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  FiCheckCircle,
  FiChevronDown,
  FiGlobe,
  FiMail,
  FiMenu,
  FiPhone,
  FiUser,
  FiX,
  FiLogOut,
} from "react-icons/fi";
import { useSelector } from "react-redux";
import { setTranslations } from "../../services/Helper";
import {
  AUTH_SESSION_CHANGED_EVENT,
  clearAuthSession,
  getPublicUserName,
  getStoredPublicUser,
} from "../../services/Auth";
import AuthModal from "../AuthModal";

const LandingHeader = ({ onOpenLogin, onOpenRegister }) => {
  const { pathname } = useLocation();
  const isHome = pathname === "/" || pathname === "/smart-school-system";
  const [menuOpen, setMenuOpen] = useState(false);
  // const [productOpen, setProductOpen] = useState(false);
  const [loginOpen, setLoginOpen] = useState(false);
  const [registerOpen, setRegisterOpen] = useState(false);
  const [publicUser, setPublicUser] = useState(getStoredPublicUser);
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const translation = useSelector((state) => state.translation);
  const [language, setLanguage] = useState(
    localStorage.getItem("lang") || "en"
  );

  const handleLanguageChange = (lang) => {
    setLanguage(lang);
    localStorage.setItem("lang", lang);
    setTranslations(lang);
  };

  // Translations are loaded centrally in App.js

  useEffect(() => {
    const updateUser = (event) => {
      setPublicUser(event.detail || getStoredPublicUser());
    };

    window.addEventListener(AUTH_SESSION_CHANGED_EVENT, updateUser);
    window.addEventListener("storage", updateUser);

    return () => {
      window.removeEventListener(AUTH_SESSION_CHANGED_EVENT, updateUser);
      window.removeEventListener("storage", updateUser);
    };
  }, []);

  useEffect(() => {
    document.body.style.overflow = loginOpen || registerOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [loginOpen, registerOpen]);

  const useExternalAuth =
    typeof onOpenLogin === "function" || typeof onOpenRegister === "function";

  const openLoginModal = () => {
    if (typeof onOpenLogin === "function") {
      onOpenLogin();
      return;
    }
    setLoginOpen(true);
  };

  const openRegisterModal = () => {
    if (typeof onOpenRegister === "function") {
      onOpenRegister();
      return;
    }
    setRegisterOpen(true);
  };

  const handleLogout = () => {
    clearAuthSession();
    setPublicUser(null);
    setUserMenuOpen(false);
    setMenuOpen(false);
    window.isChatHide = true;

    const chatRoot = document.getElementById("root");
    if (chatRoot) {
      chatRoot.remove();
    }
  };

  const userName = getPublicUserName(publicUser);

  const renderUserMenu = () => userName ? (
    <div
      className={`landing-header-user-menu ${
        userMenuOpen ? "landing-header-user-menu-open" : ""
      }`}
    >
      <button
        type="button"
        className="landing-header-user-pill"
        title={publicUser?.email || userName}
        aria-haspopup="menu"
        aria-expanded={userMenuOpen}
        onClick={() => setUserMenuOpen((current) => !current)}
      >
        <span className="landing-header-user-avatar">
          {userName.charAt(0).toUpperCase()}
        </span>
        <span>{userName}</span>
        <FiChevronDown className="landing-header-user-chevron" />
      </button>
      <div className="landing-header-user-dropdown" role="menu">
        <div className="landing-header-user-dropdown-head">
          <span className="landing-header-user-avatar landing-header-user-avatar-large">
            {userName.charAt(0).toUpperCase()}
          </span>
          <div>
            <strong>{userName}</strong>
            <p>{publicUser?.email || ""}</p>
          </div>
        </div>
        <div className="landing-header-user-detail-list">
          <div className="landing-header-user-detail-item">
            <FiUser />
            <div>
              <span>Full name</span>
              <strong>{userName}</strong>
            </div>
          </div>
          <div className="landing-header-user-detail-item">
            <FiMail />
            <div>
              <span>Email</span>
              <strong>{publicUser?.email || "Not available"}</strong>
            </div>
          </div>
          <div className="landing-header-user-detail-item">
            <FiPhone />
            <div>
              <span>Phone</span>
              <strong>{publicUser?.phoneNumber || "Not available"}</strong>
            </div>
          </div>
          <div className="landing-header-user-detail-item">
            <FiCheckCircle />
            <div>
              <span>Status</span>
              <strong>
                {publicUser?.enabled ? "Active" : "Disabled"}
                {" · "}
                {publicUser?.emailVerified ? "Verified" : "Email not verified"}
              </strong>
            </div>
          </div>
        </div>
        <button
          type="button"
          className="landing-header-user-logout"
          onClick={handleLogout}
        >
          <FiLogOut />
          Logout
        </button>
      </div>
    </div>
  ) : null;

  return (
    <header className={`landing-header ${menuOpen ? "menu-open" : ""}`}>
      <div className="landing-container landing-header-inner">
        <Link to="/" className="landing-logo">
          <img
            src="https://pub-uploads.s3.amazonaws.com/uploads/chat/web/dk4JN4AVx9_esyncing-logo.png"
            alt="eSyncing"
          />
        </Link>
        <button
          className="mobile-menu-btn"
          aria-label="Toggle navigation"
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((prev) => !prev)}
        >
          {menuOpen ? <FiX /> : <FiMenu />}
        </button>
        <nav className="landing-nav">
          <Link to="/" className={`nav-item${isHome ? " active" : ""}`} aria-current={isHome ? "page" : undefined}>{translation.home || "Home"}</Link>
          {/* Product dropdown temporarily disabled.
          <div className="nav-dropdown">
            <button className="nav-item nav-trigger">
              {translation.product || "Product"} <FiChevronDown />
            </button>
            <div className="nav-menu">
              <div className="nav-menu-grid">
                <a className="nav-menu-item" href="/smart-school-system">
                  <span className="menu-icon"><FiBookOpen /></span>
                  <div>
                    <h6>{translation.landing_header_product_item0_title || "Smart School System"}</h6>
                    <p>{translation.landing_header_product_item0_desc || "A complete platform for school communication and learning"}</p>
                  </div>
                </a>
                <a className="nav-menu-item" href="/product#interactive-demos">
                  <span className="menu-icon"><FiZap /></span>
                  <div>
                    <h6>{translation.landing_header_product_item1_title || "Interactive Product Demos"}</h6>
                    <p>{translation.landing_header_product_item1_desc || "Create hands-on product experiences"}</p>
                  </div>
                </a>
                <a className="nav-menu-item" href="/product#integrations">
                  <span className="menu-icon"><FiLayers /></span>
                  <div>
                    <h6>{translation.landing_header_product_item2_title || "AI Content & Automation"}</h6>
                    <p>{translation.landing_header_product_item2_desc || "Generate and manage AI-powered content"}</p>
                  </div>
                </a>
                <a className="nav-menu-item" href="/product#ai-chat">
                  <span className="menu-icon"><FiMessageCircle /></span>
                  <div>
                    <h6>{translation.landing_header_product_item3_title || "AI-Powered Chat for Teams & Customers"}</h6>
                    <p>{translation.landing_header_product_item3_desc || "Real-time AI-powered conversations"}</p>
                  </div>
                </a>
                <a className="nav-menu-item" href="/product#integrations">
                  <span className="menu-icon"><FiLink /></span>
                  <div>
                    <h6>{translation.landing_header_product_item4_title || "Integrations"}</h6>
                    <p>{translation.landing_header_product_item4_desc || "Connect eSyncing with your existing tools"}</p>
                  </div>
                </a>
                <a className="nav-menu-item" href="/product#virtual-hr">
                  <span className="menu-icon"><FiUsers /></span>
                  <div>
                    <h6>{translation.landing_header_product_item5_title || "Virtual HR Assistant"}</h6>
                    <p>{translation.landing_header_product_item5_desc || "HR policies, rules, and employee Q&A"}</p>
                  </div>
                </a>
                <a className="nav-menu-item" href="/product#knowledge-hub">
                  <span className="menu-icon"><FiBookOpen /></span>
                  <div>
                    <h6>{translation.landing_header_product_item6_title || "Company Knowledge Hub"}</h6>
                    <p>{translation.landing_header_product_item6_desc || "Smart self-service company knowledge base"}</p>
                  </div>
                </a>
              </div>
            </div>
          </div>
          */}
          <a href="#demo" className="nav-item">{translation.demos || "Demos"}</a>
          <a href="#how" className="nav-item">{translation.how_it_works || "How It Works"}</a>
          <a href="#pricing" className="nav-item">{translation.pricing || "Pricing"}</a>
        </nav>
        <div className="landing-cta-group">
          <div className="lang-dropdown">
            <button className="lang-pill">
              <FiGlobe />
              {language === "ja" ? "Japanese" : "English"} <FiChevronDown />
            </button>
            <div className="lang-menu">
              <button
                className={`lang-item ${language === "en" ? "active" : ""}`}
                onClick={() => handleLanguageChange("en")}
              >
                English
              </button>
              <button
                className={`lang-item ${language === "ja" ? "active" : ""}`}
                onClick={() => handleLanguageChange("ja")}
              >
                Japanese
              </button>
            </div>
          </div>
          {renderUserMenu() || (
            <>
              <button
                className="landing-btn landing-btn-ghost"
                onClick={openLoginModal}
              >
                {translation.sign_in || "Login"}
              </button>
              <button
                className="landing-btn landing-btn-primary"
                onClick={openRegisterModal}
              >
                {translation.get_started || "Get Started"}
              </button>
            </>
          )}
        </div>
      </div>
      <div className={`mobile-menu ${menuOpen ? "open" : ""}`}>
        <div className="mobile-menu-inner">
          <Link to="/" className={isHome ? "active" : undefined} aria-current={isHome ? "page" : undefined} onClick={() => setMenuOpen(false)}>{translation.home || "Home"}</Link>
          {/* Product dropdown temporarily disabled.
          <div className="mobile-section">
            <button
              className="mobile-section-toggle"
              onClick={() => setProductOpen((prev) => !prev)}
              aria-expanded={productOpen}
            >
              <span>{translation.product || "Product"}</span>
              <FiChevronDown className={`chev ${productOpen ? "open" : ""}`} />
            </button>
            <div className={`mobile-sublist ${productOpen ? "open" : ""}`}>
              <a href="/smart-school-system" onClick={() => setMenuOpen(false)}>
                {translation.landing_header_product_item0_title || "Smart School System"}
              </a>
              <a href="/product#interactive-demos" onClick={() => setMenuOpen(false)}>
                {translation.landing_header_product_item1_title || "Interactive Product Demos"}
              </a>
              <a href="/product#ai-chat" onClick={() => setMenuOpen(false)}>
                {translation.landing_header_product_item3_title || "AI-Powered Chat"}
              </a>
              <a href="/product#virtual-hr" onClick={() => setMenuOpen(false)}>
                {translation.landing_header_product_item5_title || "Virtual HR Assistant"}
              </a>
              <a href="/product#knowledge-hub" onClick={() => setMenuOpen(false)}>
                {translation.landing_header_product_item6_title || "Company Knowledge Hub"}
              </a>
              <a href="/product#integrations" onClick={() => setMenuOpen(false)}>
                {translation.landing_header_product_item4_title || "Integrations"}
              </a>
              <a href="/product#integrations" onClick={() => setMenuOpen(false)}>
                {translation.landing_header_product_item2_title || "AI Content & Automation"}
              </a>
            </div>
          </div>
          */}
          <a href="#demo" onClick={() => setMenuOpen(false)}>{translation.demos || "Demos"}</a>
          <a href="#how" onClick={() => setMenuOpen(false)}>{translation.how_it_works || "How It Works"}</a>
          <a href="#pricing" onClick={() => setMenuOpen(false)}>{translation.pricing || "Pricing"}</a>
          <div className="mobile-section">
            <div className="mobile-section-title">{translation.language || "Language"}</div>
            <div className="mobile-lang">
              <button
                className={`lang-item ${language === "en" ? "active" : ""}`}
                onClick={() => handleLanguageChange("en")}
              >
                English
              </button>
              <button
                className={`lang-item ${language === "ja" ? "active" : ""}`}
                onClick={() => handleLanguageChange("ja")}
              >
                Japanese
              </button>
            </div>
          </div>
          <div className="mobile-menu-actions">
            {renderUserMenu() || (
              <>
                <button
                  className="landing-btn landing-btn-ghost"
                  onClick={() => {
                    setMenuOpen(false);
                    openLoginModal();
                  }}
                >
                  {translation.sign_in || "Login"}
                </button>
                <button
                  className="landing-btn landing-btn-primary"
                  onClick={() => {
                    setMenuOpen(false);
                    openRegisterModal();
                  }}
                >
                  {translation.get_started || "Get Started"}
                </button>
              </>
            )}
          </div>
        </div>
      </div>
      {!useExternalAuth && (
        <AuthModal
          isOpen={loginOpen || registerOpen}
          mode={registerOpen ? "register" : "login"}
          onClose={() => {
            setLoginOpen(false);
            setRegisterOpen(false);
          }}
          onSwitchMode={(nextMode) => {
            setLoginOpen(nextMode === "login");
            setRegisterOpen(nextMode === "register");
          }}
        />
      )}
    </header>
  );
};

export default LandingHeader;
